import { CallState } from "@b2bportal/core-types";
import dayjs from "dayjs";
import type {
  CarsAvailabilitySearchState,
  CarsAvailabilityState,
} from "./types";
import {
  CarSortOptionEnum,
  DropoffType,
  type FilterState,
} from "~core-cars/types";

export const initialFiltersState: FilterState = {
  priceRange: {
    max: Number.MAX_SAFE_INTEGER,
    min: 0,
  },
  freeCancellation: false,
  carType: [],
  minimumBags: 0,
  supplier: [],
  specification: {
    unlimitedMileage: false,
    automaticTransmission: false,
    airCondition: false,
  },
  passenger: [],
};

export const initialCarsAvailabilitySearchState: CarsAvailabilitySearchState = {
  searchFormValues: {
    pickupDate: undefined,
    pickupTime: dayjs().hour(10).minute(0).toISOString(),
    pickupDateTime: undefined,
    pickupLocation: undefined,
    dropoffTime: dayjs().hour(10).minute(0).toISOString(),
    dropoffDate: undefined,
    dropoffDateTime: undefined,
    dropoffLocation: undefined,
    dropoffType: DropoffType.SameLocation,
    driverAge: 25,
  },
  sort: CarSortOptionEnum.Recommended,
  filters: initialFiltersState,
  map: {
    zoom: 13,
  },
};

export const initialCarAvailabilityState: CarsAvailabilityState = {
  ...initialCarsAvailabilitySearchState,
  searchResult: {
    state: CallState.NotCalled,
  },
  initialized: CallState.NotCalled,
};
